import React, { ReactElement } from 'react'
import Layout from '../../../components/layout'
import MerchantShopList from '../../../components/Merchant/Shops'

const MerchantShopPage = (): ReactElement => {
  return (
    <Layout >
      <MerchantShopList />
    </Layout>
  )
}

export default MerchantShopPage
